import config from "@/config";

export const logIt = (type, ...args) => {
  if (config?.allowConsoles && !window.disableLogs) {
    console.log(type, ":", ...args);
  }
};
